import { render, staticRenderFns } from "./HonjoSteps.vue?vue&type=template&id=64b760dc"
import script from "./HonjoSteps.vue?vue&type=script&lang=ts"
export * from "./HonjoSteps.vue?vue&type=script&lang=ts"
import style0 from "./HonjoSteps.vue?vue&type=style&index=0&id=64b760dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports